import { render } from "./PlayerUpdate.vue?vue&type=template&id=3ec7f2f0&scoped=true"
import script from "./PlayerUpdate.vue?vue&type=script&lang=js"
export * from "./PlayerUpdate.vue?vue&type=script&lang=js"

import "./PlayerUpdate.vue?vue&type=style&index=0&id=3ec7f2f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec7f2f0"]])

export default __exports__